module.exports = __webpack_public_path__ + "img/3.0d6f5a78.png";